<template>
  <div class="mex-asset-preview">
    <div>
      <Button size="small" :loading="uploading" @click="pick">上传到七牛</Button>
      <input ref="file" type="file" :accept="accept" style="display:none" @change="onFile">
    </div>
    <p v-if="url" class="mex-dim-hint">{{url}}</p>
    <img v-if="url && kind === 'image'" :src="url" class="mex-asset-preview-img">
    <audio v-else-if="url && kind === 'audio'" :src="url" controls class="mex-asset-preview-audio"></audio>
    <video v-else-if="url && kind === 'video'" :src="url" controls class="mex-asset-preview-video"></video>
  </div>
</template>

<script>
import { assetKind, assetUrl } from './mex-asset'

export default {
  name: 'MexAssetPreview',
  props: {
    path: {
      type: String,
      default: ''
    },
    skill: {
      type: String,
      default: ''
    },
    bank: {
      type: String,
      default: 'comp'
    },
    accept: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      uploading: false
    }
  },
  computed: {
    url () {
      return assetUrl(this.path, this.skill)
    },
    kind () {
      return assetKind(this.url)
    },
    uploadUrl () {
      return this.bank === 'speak' ? '/mex/speak/questions/asset' : '/mex/comp/questions/asset'
    }
  },
  methods: {
    pick () {
      if (!this.skill) {
        this.$Message.warning('请先选择技能')
        return
      }
      this.$refs.file && this.$refs.file.click()
    },
    onFile (e) {
      let file = e.target && e.target.files && e.target.files[0]
      e.target.value = ''
      if (!file) return
      let fd = new FormData()
      fd.append('file', file)
      fd.append('skill', this.skill)
      let hint = String(this.path || '').trim()
      if (hint) fd.append('fileName', hint)
      this.uploading = true
      this.$http.post(this.uploadUrl, fd, { transformRequest: [] }).then(res => {
        this.uploading = false
        if (res.status === 'ok' && res.data && res.data.fileName) {
          this.$emit('input', res.data.fileName)
          this.$Message.success('已上传')
        } else {
          this.$Message.error(res.msg || '上传失败')
        }
      }).catch(() => {
        this.uploading = false
        this.$Message.error('上传失败')
      })
    }
  }
}
</script>

<style lang="less">
.mex-asset-preview {
  margin-top: 8px;
}

.mex-asset-preview-img {
  display: block;
  max-width: 240px;
  max-height: 160px;
  object-fit: contain;
  background: #f8f8f9;
  border: 1px solid #e8eaec;
}

.mex-asset-preview-audio,
.mex-asset-preview-video {
  display: block;
  width: 100%;
  max-width: 360px;
  margin-top: 4px;
}

.mex-asset-preview-video {
  max-height: 200px;
}
</style>



// WEBPACK FOOTER //
// MexAssetPreview.vue?3f7a5e1a